export default __webpack_public_path__ + "static/media/Scepter of Return.c0d1c5c9.jpg";